import {
  hasModifyPermissionsSelector,
  useClientStore,
} from 'react-scale/components/ExpertManagement/stores/client.store';

import { shallow } from 'zustand/shallow';

export const useCanUserModifyCommunity = () =>
  useClientStore(hasModifyPermissionsSelector, shallow);
